"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.indicatorRegion = indicatorRegion;
exports.clearIndicators = clearIndicators;
exports.default = indicate;

var _bloodyOffset = _interopRequireDefault(require("bloody-offset"));

const MARGIN = 3;
const THROTTLE = 10;

function indicatorRegion(editorFrame, target, offsetFn = _bloodyOffset.default, boundingRectOverride) {
  const outerShape = offsetFn(editorFrame);
  const b = boundingRectOverride || target.getBoundingClientRect();
  const innerShape = {
    top: b.top,
    left: b.left,
    width: b.right - b.left,
    height: b.bottom - b.top
  };
  return {
    width: innerShape.width,
    height: innerShape.height,
    left: outerShape.left + innerShape.left,
    top: outerShape.top + innerShape.top
  };
}

function indicatorContainer() {
  return document.fullscreenElement || document.webkitFullscreenElement || document.body;
}

function clearIndicators(parent) {
  const container = parent || indicatorContainer();
  Array.from(container.querySelectorAll(".a11y-checker-selection-indicator")).forEach(existingElem => {
    existingElem.parentNode.removeChild(existingElem);
  });
}

function indicate(editor, elem, margin = MARGIN) {
  clearIndicators();
  const editorFrame = editor.getContainer().querySelector("iframe");
  const el = document.createElement("div");
  el.className = "a11y-checker-selection-indicator";
  const region = indicatorRegion(editorFrame, elem); // The z-index below is set to be one below the Instructure UI tray
  // that the a11y checker uses.  It may need to be updated in the future.

  el.setAttribute("style", `
    border: 2px solid #000;
    background-color: #008EE2;
    position: absolute;
    display: block;
    borderRadius: 5px;
    z-index: 9998;
    left: ${region.left - margin}px;
    top: ${region.top - margin}px;
    width: ${region.width + 2 * margin}px;
    height: ${region.height + 2 * margin}px;
    opacity: 0.5;
  `);
  indicatorContainer().appendChild(el);
  el.style.opacity = 0.8;
  el.style.transition = "opacity 0.4s";
  let lastAdjust = 0;

  const adjust = timestamp => {
    if (timestamp - lastAdjust > THROTTLE) {
      lastAdjust = timestamp;

      if (el.parentElement === null) {
        return;
      }

      const boundingRect = elem.getBoundingClientRect();
      const region = indicatorRegion(editorFrame, elem, _bloodyOffset.default, boundingRect);
      const editorFrameOffset = (0, _bloodyOffset.default)(editorFrame);
      el.style.left = `${region.left - margin}px`;
      el.style.top = `${region.top - margin}px`;
      el.style.display = "block";

      if (boundingRect.top < 0) {
        const newHeight = region.height + boundingRect.top;

        if (newHeight < 0) {
          el.style.display = "none";
        }

        const newTop = region.height - newHeight;
        el.style.height = `${newHeight}px`;
        el.style.marginTop = `${newTop}px`;
      }

      if (boundingRect.bottom > editorFrameOffset.height) {
        const newHeight = region.height + (editorFrameOffset.height - boundingRect.bottom);

        if (newHeight < 0) {
          el.style.display = "none";
        }

        el.style.height = `${newHeight}px`;
      }

      window.requestAnimationFrame(adjust);
    }
  };

  window.requestAnimationFrame(adjust);
}